import React 				from 'react';
import ReactDOM 			from 'react-dom';
import ReactJson			from 'react-json-view';
import BLComponent			from '../../core/_BLComponent.jsx';
import Modal 				from '../../modals/_DynamicModal.jsx';

import ErrorModalBody		from './_ErrorModalBody.jsx';

export default class ErrorModal extends BLComponent 
{
	constructor ( props, context )
	{
		super( props, context );	// This should come first. 

		this.state	= 	{
							showModal: true
						,	errorModalList: 
								{
									generalError: {
											size 		: "s"
										,	btnList 	: [
												{ name: "Cancel", class: "text--bold", func:()=>{this.cancelSave()}}
											,	{ name:"Try again", class: "btn--cta text--bold", func:()=>{this.retrySave()}}
										]
									}
								,	partoutError: {
											size 		: "s"
										,	btnList 	: [
												{ name: "Cancel", class: "text--bold", func:()=>{this.toggleModal()}}
											,	{ name:"Try again", class: "btn--cta text--bold", func:()=>{this.button()}}
										]
									}
								,	failure: {
										size 		: "s"
										,	btnList 	: [
												{ name:"Done", class: "btn--cta text--bold l-full-width", func:()=>{this.cancelSave()}}
										]
									}
								,	editError: {
										size 		: "s"
										,	btnList 	: [
												{ name: "Cancel", class: "text--bold", func:()=>{this.toggleModal()}}
											,	{ name:"Try again", class: "btn--cta text--bold", func:()=>{this.button()}}
										]
									}
								,	editFailure: {
										size 		: "s"
										,	btnList 	: [
												{ name: "Cancel", class: "text--bold", func:()=>{this.toggleModal()}}
											,	{ name:"Try again", class: "btn--cta text--bold", func:()=>{this.button()}}
										]
									}
								,	updateQtyError: {
										size 		: "s"
										,	btnList 	: [
										]
									}

								}
						}
						
	}

	componentDidMount() 
	{

	}

	render()
	{
		return (
			<div>
				{this.renderErrorModal()}
			</div>
		)
	}

	renderErrorModal() {
		const {itemType, errorType} = this.props.data;
		const errorModalData = this.state.errorModalList[errorType];

		const errorModalBody = () => {
			return ( 
			<ErrorModalBody data={{itemType:itemType, errorType:errorType}}/>
			)
		}

		const modalOption = {
			title: { name: "", showClose: true, display: false, clickable: false, callback:()=>{this.clickTitle()} }
		,	showCloseButton: false
		,	closeOnEscape: true
		,	modalSize: errorModalData.size /* s m l */
		,	ModalBody: errorModalBody
		,	modal_allscreen: true
		,	ModalFooter: {
				buttons: {
					direction: "row"
				,	list: errorModalData.btnList
				}
			,	dontshowagain: { msg:"Don't show again", display: false, func:()=>{this.dontshowagain()}}
			}
		,	closeFunc: ()=>this.closeFunc()
		}

		return (
			<div>{this.state.showModal&& <Modal data={ modalOption }/> }</div>
		)
	}

	closeFunc() {
		const {itemType, errorType} = this.props.data;
		if ( (errorType == "generalError") || (errorType == "failure") ) 
			this.cancelSave();
		switch(errorType)
		{
			case "generalError":
			case "failure":
				this.cancelSave();
				break;
			case "updateQtyError":
				this.props.func.toggleUpdateErrorModal();
		} 
	}

	toggleModal() {
		this.setState({showModal:!this.state.showModal});
	}

	cancelSave() {
		this.props.func.cancelSaveItems();
	}

	retrySave() {
		this.props.func.retrySaveItems();
	}

	clickTitle() {
		return null;
	}

	button()
	{
		return null;
	}

};

